export default __webpack_public_path__ + "static/media/GPA_HomeBanner.5a52d583.mp4";